<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content" style="margin-top: 20px;">
    <!-- Form Entry Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        
        @if (!showFormLoader) {
<div>
          <!-- Entity Information Table -->
          <table class="table table-bordered form-inline enityDetails custom-table" style="margin-bottom: 25px;">
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span><strong>{{ item.key }}</strong></span>
              </td>
}
            </tr>
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span>{{ item.value }}</span>
              </td>
}
            </tr>
          </table>
          <table class="table table-bordered form-inline custom-table">
            <thead>
              <tr>
                <th colspan="4">{{modalTitle}}</th>
              </tr>
              <tr>
                <th colspan="2"></th>
                <th colspan="1" class="subHeader">
                  <span class="schd-ins">(a) Beginning of tax year</span>
                </th>
                <th colspan="1" class="subHeader">
                  <span class="schd-ins">(b) End of tax year</span>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (row of scheduleFFormView.rows; track itemTracker(i, row); let i = $index) {
<tr>
                <td style="width: 58px">{{row.num}}</td>
                <td>{{row.description}}</td>
                <td style="width: 110px" align="right">
                  @if (row.num != 8 && row.num != 10 && row.num != 9 && row.num != 11 && row.num != 12) {
<div>
                    <input class="form-control input-md numText"
                           type="number"
                           [value]="row.value1"
                           (input)="updateValue1(row, $event)"
                           [disabled]="row.is_editable"
                           placeholder=""
                           aria-describedby="basic-addon2">
                  </div>
}
                  @if (row.num == 9) {
<div>
                    <input class="form-control input-md numText"
                           type="number"
                           [value]="row.value1"
                           (input)="updateValue1(row, $event)"
                           placeholder=""
                           aria-describedby="basic-addon2">
                  </div>
}
                </td>
                <td style="width: 110px" align="right">
                  @if (row.num != 9 && row.num != 10) {
<div>
                    <input class="form-control input-md numText"
                           type="number"
                           [value]="row.value2"
                           (input)="updateValue2(row, $event)"
                           [disabled]="row.is_editable"
                           placeholder=""
                           aria-describedby="basic-addon2">
                  </div>
}
                  @if (row.num == 10) {
<div>
                    <input class="form-control input-md numText"
                           type="text"
                           placeholder="30%"
                           [disabled]="true"
                           aria-describedby="basic-addon2">
                  </div>
}
                  @if (row.num == 11) {
<div style="margin-top: 4px;">
                    <div style="text-align: center;">Adjust Round-Off</div>
                    <input class="form-control input-md numText"
                           type="number"
                           [value]="row.value3"
                           (input)="updateValue3(row, $event)"
                           [disabled]="row.is_editable3"
                           placeholder=""
                           aria-describedby="basic-addon2">
                  </div>
}
                </td>
              </tr>
}
            </tbody>
          </table>
        </div>
}
        
        @if (!showFormLoader && unallocatedAmount) {
<div>
          <table class="table table-bordered form-inline custom-table">
            <tbody>
              @for (row of unallocatedAmount; track $index; let rowIndex = $index) {
<tr>
                @for (col of row; track $index; let colIndex = $index) {
<td width="25%">
                  <span class="bg-grey">
                    @if (colIndex < 3) {
<span>( {{col.name}} )</span>
}
                    @if (colIndex == 3) {
<span>(Exception?) :
                      <input type="checkbox"
                             [ngModel]="col.exception_flag === 'Y'"
                             (ngModelChange)="col.exception_flag = $event ? 'Y' : 'N'"
                             [disabled]="row[colIndex-1].value == 0">
                      <span class="diag_check">By Pass Diag.</span>
                    </span>
}
                  </span>
                  <br>
                  @if (colIndex < 3) {
<span [ngClass]="{'color-red' : col.value < 0 }">
                    <span>{{col.value | number}}</span>
                  </span>
}
                  @if (colIndex == 3) {
<span>
                    <span>Exception Reason : </span>
                    <span>
                      <input type="text"
                             class="form-control exception_input"
                             [ngClass]="{'input_disabled': col.exception_flag==='N'}"
                             name="exceptionMsg"
                             [(ngModel)]="col.exception_msg"
                             [disabled]="col.exception_flag==='N'">
                    </span>
                  </span>
}
                </td>
}
              </tr>
}
            </tbody>
          </table>
        </div>
}
      </div>
    </div>
}

    <!-- Form View Tab -->
    @if (activeTab === 2) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      @if (showFormLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}
      @if (!showFormLoader) {
<div class="L_SCHD_F">
        <table>
          <thead>
            <tr>
              <th colspan="4">
                <span class="schd-name">Schedule F</span>
                <span class="schd-desc">Increase (Decrease) in Reserves (section 807) and Company/Policyholder Share Percentage</span>
                <span class="schd-ins">(section 812)(see instructions)</span>
              </th>
            </tr>
            <tr>
              <th colspan="2"></th>
              <th colspan="1" class="subHeader">
                <span class="schd-sub">(a) Beginning of tax year</span>
              </th>
              <th colspan="1" class="subHeader">
                <span class="schd-sub">(b) End of tax year</span>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (row of scheduleFFormView.rows; track itemTracker($index, row)) {
<tr>
              <td class="lineNo">{{row.num}}</td>
              <td class="lineDesc">{{row.description}}</td>
              <td>
                @if (row.num != 8 && row.num != 10 && row.num != 11 && row.num != 12) {
<div
                     [ngClass]="{'color-red': row.value1 < 0 }"
                     class="input_enabled">
                  {{row.value1 | number}}
                </div>
}
              </td>
              <td>
                @if (row.num != 9) {
<div
                     [ngClass]="{'color-red': row.value2 < 0 }"
                     class="input_enabled">
                  {{row.value2 | number}}
                </div>
}
                @if (row.num == 9) {
<div class="input_disabled"></div>
}
              </td>
            </tr>
}
          </tbody>
        </table>
      </div>
}
    </div>
}

    <!-- Audit Tab -->
    @if (activeTab === 3) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        @if (showRequestLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        @if (!showRequestLoader) {
<div class="main-header">
          <div class="col-sm-4">
            <span style="text-align: center; display: block;">Transaction Number</span>
          </div>
          <div class="col-sm-3">
            <span>User</span>
          </div>
          <div class="col-sm-2">
            <span>Date</span>
          </div>
          <div class="col-sm-3" style="padding-left: 20px">
            <span>View Transactions</span>
          </div>
        </div>
}
        @if (batchLoader) {
<div class="viewBatchLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        @if (!showRequestLoader && (!BatchList || BatchList.length === 0)) {
<div style="padding: 20px; text-align: center; color: #666;">
          No audit records available
        </div>
}
        @for (batchItem of BatchList; track $index; let batchIndex = $index) {
<div class="audit-container">
          <div class="audit-row">              
            <div class="col-sm-4">
              <span style="text-align: center; display: block;">{{batchItem.TRANSACTION_ID}}</span>
            </div>
            <div class="col-sm-3">
              <span>{{batchItem.USER_FIRST_NAME}} {{batchItem.USER_LAST_NAME}}</span>
            </div>
            <div class="col-sm-2">
              <span>{{batchItem.CREATED_ON}}</span>
            </div>
            <div class="col-sm-3">                   
              <button type="button" 
                      class="btn btn-primary view-trans-btn" 
                      (click)="showUploads(batchIndex, batchItem.TRANSACTION_ID)" 
                      [disabled]="batchItem.show_transaction">
                View Transactions
              </button> 
              <span>@if (batchItem.show_transaction) {
<i class="fa fa-spinner fa-spin gt-refresh"></i>
}</span>
            </div>
          </div>
          @if (batchItem.TOGGLE) {
<div class="transaction-details">
            @if (batchLoader) {
<div class="viewBatchLoader">
              <i class="fa fa-spinner fa-spin gt-refresh"></i>
            </div>
}
            @if (showBatchData && BatchListData && BatchListData.length > 0) {
<table class="table table-bordered form-inline custom-table">
              <thead>
                <tr style="background: #cd5763;color: white;font-weight: bold;">
                  <td style="width: 58px;padding: 0 20px;">#</td>
                  <td style="padding: 0 20px;">Description</td>
                  <td style="width: 110px;padding: 0;text-align: center;">Column A</td>
                  <td style="width: 110px;padding: 0;text-align: center;">Column B</td>
                </tr>
              </thead>
              <tbody>
                @for (batchData of BatchListData; track itemTracker($index, batchData)) {
<tr>
                  <td style="width: 58px;padding: 0 20px;">{{batchData.LINE_NO}}</td>
                  <td style="padding: 0 20px;">{{batchData.LINE_DESCRIPTION || batchData.ATTRIBUTE_NAME}}</td>
                  <td style="width: 110px;padding: 0;" align="right">
                    <div style="background: white;border-radius: 4px;margin: 2px;text-align: center;">
                      {{batchData.ATTRIBUTE_VALUE | number:'1.0-0'}}
                    </div>
                  </td>
                  <td style="width: 110px;padding: 0;" align="right">
                    <div style="background: white;border-radius: 4px;margin: 2px;text-align: center;">
                      {{batchData.ATTRIBUTE_VALUE_B | number:'1.0-0'}}
                    </div>
                  </td>
                </tr>
}
              </tbody>
            </table>
}
            <!-- Show message if no data -->
            @if (showBatchData && (!BatchListData || BatchListData.length === 0)) {
<div style="padding: 20px; text-align: center; color: #666;">
              No transaction data available
            </div>
}
          </div>
}
        </div>
}
      </div>
    </div>
}
  </div>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button  
          class="save-button"  
          type="button"  
          [disabled]="isSaveClicked"  
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button  
          class="reset-button"  
          type="button"  
          (click)="reset()">Reset</button>
}
  <button class="cancel-button"  
          type="button"  
          (click)="cancel()">Cancel</button>
</div>

